import Vue from "vue";
import validationMixin from "@/mixins/validationMixin";
export default Vue.extend({
    mixins: [validationMixin],
    props: {
        templateConfig: {}
    }
});
